export const LOADING="LOADING";
export const ERROR="ERROR";
export const SUCCESS="SUCCESS";